
import React from 'react';
import PropTypes from 'prop-types';
import './gbi-header-burger.scss';

/* eslint-disable max-len */
const GBIHeaderBurger = ({ onClick, className }) => (
  <svg onClick={ onClick }
    data-cy="gbi-header-burger"
    className={ className ? 'gbi-header-burger ' + className : 'gbi-header-burger' }
    viewBox="0 0 494.185 347.784">
    <g>
      <path d="M340.783,299.091H3.815v50.693H269A468.746,468.746,0,0,0,340.783,299.091Z" transform="translate(-3.815 -2)"/>
      <path d="M3.815,150.821v50.693H426.834a466.773,466.773,0,0,0,29.1-50.693Z" transform="translate(-3.815 -2)"/>
      <path d="M498,2.55H3.815V53.243H491.187C493.871,42.005,498,18,498,2Z" transform="translate(-3.815 -2)"/>
    </g>
  </svg>
);

GBIHeaderBurger.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string
};

export default GBIHeaderBurger;
